import { ISendEmail } from 'interfaces/api/send-email.interface';
import { ApiPost } from '.';

export const sendEmail = async (data: ISendEmail) => {
  return await ApiPost<ISendEmail>('/send-email', data);
};
